module.exports = __webpack_public_path__ + "img/nav-menu-normal.5f94d1bd.svg";